import { useState } from 'react';
import ReactDOM from "react-dom/client";
import './App.css';
import Direction from './Features/Configurator/Types/Direction';
import ViewType from './Features/Configurator/Types/ViewType';
import MainLayout from './Features/Configurator/Layouts/MainLayout/MainLayout';
import { configuration, ConfiguratorContext } from './Features/Configurator/Contexts/Configuration';
import { getNextView, getNode, validateNavigation } from './Features/Configurator/Services/Navigation';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFoundView from "./Views/NotFoundView/NotFoundView"
import ResultLayout from './Features/Configurator/Layouts/ResultLayout/ResultLayout';
import HomeOffersView from './Features/Offers/Views/HomeOffersView/HomeOffersView';
import ProfessionalOffersView from './Features/Offers/Views/ProfessionalOffersView/ProfessionalOffersView';
import EnterpriseOffersView from './Features/Offers/Views/EnterpriseOffersView/EnterpriseOffersView';
import OfferDetailsView from './Features/Offers/Views/OfferDetailsView/OfferDetailsView';

function App()
{
	let [type, setType] = useState(ViewType.verifyCoverage)

	let node = getNode(type)

	const onNavigate = async (direction: Direction) => {
		if (direction === Direction.next) {
			let validated = await validateNavigation(configuration, type)
			if (!validated) {
				return;
			}
		}

		let newType = getNextView(configuration, type, direction)
		if (newType !== undefined) {
			setType(newType)
		}
	}

	return (
		<BrowserRouter>
			<Routes>
				<Route path="configurator" element={
					<ConfiguratorContext.Provider value={configuration}>
						<MainLayout canGoNext={node?.next(configuration) === undefined ? false : true} canGoPrevious={node?.previous(configuration) === undefined ? false : true} percentage={node?.percentage} onNavigate={onNavigate}>
							{node === undefined ? <div>error</div> : node.content()}
						</MainLayout>
					</ConfiguratorContext.Provider>
				} />
				<Route path="offerte-per-la-casa" element={
					<HomeOffersView />
				} />
				<Route path="offerte-per-i-professionisti" element={
					<ProfessionalOffersView />
				} />
				<Route path="offerte-per-le-aziende" element={
					<EnterpriseOffersView />
				} />
				<Route path="dettaglio-offerta/:id/:customerType" element={
					<OfferDetailsView />
				} />
				<Route path="*" element={
					<ResultLayout>
						<NotFoundView />
					</ResultLayout>
				} />
			</Routes>
		</BrowserRouter>

	)
}

export default App;